/** @jsx jsx */
import { Fields, Form2 } from "@cd2/forms"
import { jsx } from "@emotion/core"
import { useState } from "react"
import { useAsyncEffect } from "../../hooks/useAsyncEffect"
import { IRecord } from "../../types/schema"

type ISalesRep = IRecord<"sales_reps", "name">

export function SalesRepSelectList({
  value,
  onChange,
  disabled,
  error,
  required,
  isClearable,
  branchId,
  label,
  filter,
}: {
  value?: string | null
  onChange(id: string, salesRep: ISalesRep): void
  disabled?: boolean
  error?: string
  required?: boolean
  branchId?: string
  isClearable?: boolean
  label?: React.ReactNode
  filter?: any
}) {
  const skeem = window.skeem
  const [query, setQuery] = useState("")

  const [salesReps, setSalesReps] = useState<ISalesRep[] | null>(null)

  function handleChange(id: string) {
    if (!salesReps) {
      return
    }
    onChange(id, salesReps.find(w => w.id === id)!)
  }

  useAsyncEffect(async () => {
    const skeemFilter = {
      and: [
        {
          matches: {
            name: { like: query },
          },
        },
      ] as any[],
    }
    if (branchId) {
      skeemFilter.and.push({
        exists: { path: [{ name: "customers", filter: { matches: { branch: branchId } } }] },
      })
    }
    if (filter) {
      skeemFilter.and.push(filter)
    }
    const salesReps = await skeem.fetch2<ISalesRep[]>({
      model: {
        name: "sales_reps",
        attributes: ["name"],
        filter: skeemFilter,
        sort: { by: "name", direction: "desc" },
        paginate: { size: 30 },
      },
    })
    setSalesReps(salesReps)
  }, [query, branchId, JSON.stringify(filter)])

  if (!salesReps) {
    return <div>Loading</div>
  }

  return (
    <Fields.Select2
      label={
        <Form2.FieldLabel fieldName="sales_rep" label={label ?? "Sales Rep"} required={required} />
      }
      options={salesReps}
      onChange={value => handleChange(value?.id)}
      value={salesReps.find(v => v.id === value)}
      getOptionLabel={opt => opt.name}
      getOptionValue={opt => opt.id}
      disabled={disabled}
      error={error}
      isClearable={isClearable}
      onInputChange={setQuery}
      inputValue={query}
      components={{
        SingleValue: props => {
          const { innerProps, getStyles } = props
          const lead = props.data

          return (
            <div
              {...innerProps}
              style={{
                ...getStyles("singleValue", props),
              }}
            >
              <div>{lead?.name}</div>
            </div>
          )
        },
        Option: props => {
          const { innerProps, innerRef, getStyles } = props
          const lead = props.data as ISalesRep

          return (
            <div
              ref={innerRef}
              {...innerProps}
              style={{
                ...getStyles("option", props),
              }}
            >
              <div>{lead?.name}</div>
            </div>
          )
        },
      }}
    />
  )
}
